module.exports = __webpack_public_path__ + "avatar_all.c5a509acee8aab3a1f62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/avatar_all.png
// module id = 1044
// module chunks = 2